<template>
  <BModal
    :id="id"
    :ref="id"
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    hide-header
    size="md"
    :centered="true"
  >
    <div class="d-flex justify-content-end">
      <button
        class="btn p-0"
        @click="$bvModal.hide(id)"
      >
        <feather-icon
          icon="XIcon"
          size="20"
          class="text-black"
        />
      </button>
    </div>
    <div
      v-if="!isLeftAligned"
      class="text-center my-1"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png"
        alt="Warning"
        class="m-auto"
        style="max-width: 120px;"
      >
    </div>
    <h4
      class="text-black font-bold mt-1"
      :class="isLeftAligned ? 'text-left px-3' : 'text-center'"
    >
      {{ title }}
    </h4>
    <p
      class="text-[#828282] my-1"
      :class="isLeftAligned ? 'text-left px-3' : 'text-center px-2'"
    >
      {{ description }}
    </p>
    <slot name="body" />
    <BRow
      class="flex justify-center mb-2 px-2"
      :class="{'flex-row-reverse': isRemove}"
    >
      <BCol>
        <BButton
          class="rounded-lg"
          :variant="isRemove ? 'primary' : 'outline-primary'"
          block
          @click="$bvModal.hide(id)"
        >
          {{ cancelText }}
        </BButton>
      </BCol>
      <BCol>
        <BButton
          class="rounded-lg"
          :variant="loading ? 'secondary' : (isRemove ? 'outline-primary' : 'primary')"
          :disabled="loading"
          block
          @click="onConfirm"
        >
          <BSpinner
            v-if="loading"
            variant="light"
            small
            class="mr-1"
          />
          {{ confirmText }}
        </BButton>
      </BCol>
    </BRow>
  </BModal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'modal-confirm',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    typeModal: {
      type: String,
      default: 'remove',
    },
  },
  computed: {
    isRemove() {
      return ['remove', 'unlink'].includes(this.typeModal)
    },
    isLeftAligned() {
      return ['unlink', 'edit'].includes(this.typeModal)
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>
